module.exports = __webpack_public_path__ + "img/drag-and-drop.a7c1e12c.svg";